angular.module('trainerWebApp.resources').factory('deleteSeriesResource', ['$resource', 'errorHandler',
  function($resource, errorHandler) {

    var DeleteSeriesResource = $resource(mfConfig.gaviotaApiBaseUrlSegment + '/series/:seriesId');

    DeleteSeriesResource.prototype.send = function send(seriesId, resultCb, errorCb) {
      return DeleteSeriesResource['delete']({seriesId: seriesId}, {}, resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
    };

    return new DeleteSeriesResource;
  }
]);
